export default "__VITE_ASSET__a683bd6e__"